/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CrmResidentCountResponse
 */
export interface CrmResidentCountResponse {
    /**
     * 
     * @type {number}
     * @memberof CrmResidentCountResponse
     */
    count: number;
}

/**
 * Check if a given object implements the CrmResidentCountResponse interface.
 */
export function instanceOfCrmResidentCountResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function CrmResidentCountResponseFromJSON(json: any): CrmResidentCountResponse {
    return CrmResidentCountResponseFromJSONTyped(json, false);
}

export function CrmResidentCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CrmResidentCountResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
    };
}

export function CrmResidentCountResponseToJSON(value?: CrmResidentCountResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
    };
}

